export const DEMO_NAME_UPDATE_CLICK = 'DEMO_NAME_UPDATE_CLICK';
export const DEMO_PHONE_UPDATE_CLICK = 'DEMO_PHONE_UPDATE_CLICK';
export const DEMO_EMAIL_UPDATE_CLICK = 'DEMO_EMAIL_UPDATE_CLICK';
export const DEMO_PROFILE_SET_CLICK = 'DEMO_PROFILE_SET_CLICK';
export const DEMO_LOGOUT_CLICK = 'DEMO_LOGOUT_CLICK';
export const DEMO_PROFILE_CONTINUE_CLICK = 'DEMO_PROFILE_CONTINUE_CLICK';
